import { createClient, type SupabaseClient } from '@supabase/supabase-js'

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined

/** True when the panel has been configured with a Supabase project. */
export const isConfigured = Boolean(url && anonKey && !anonKey.startsWith('REEMPLAZAR'))

export const supabase: SupabaseClient = createClient(url ?? 'http://localhost:54321', anonKey ?? 'missing-anon-key', {
  auth: { persistSession: true, autoRefreshToken: true, storageKey: 'amaluza-admin-auth' },
})

export const APP_NAME = (import.meta.env.VITE_APP_NAME as string | undefined) ?? 'RutaSur'
export const MAP_TILE_URL = (import.meta.env.VITE_MAP_TILE_URL as string | undefined) ?? 'https://tile.openstreetmap.org/{z}/{x}/{y}.png'
export const MAP_ATTRIBUTION = (import.meta.env.VITE_MAP_ATTRIBUTION as string | undefined) ?? '&copy; OpenStreetMap contributors'
